import React, { useState } from "react";
//import "./ModalStyles.css";

const CancelMeetingModal = ({ isOpen, onClose, onSave, setIsMeetingOpen }) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!comment.trim()) {
      setError("Comment is required");
      return;
    }
    setError("");
    onSave(comment);
    setComment("");
    onClose();
  };

  const handleCreateAndSave = () => {
    if (!comment.trim()) {
      setError("Comment is required");
      return;
    }
    setError("");
    onSave(comment);
    setComment("");
    onClose();
    setIsMeetingOpen(true);
  };

  const handleCancel = () => {
    setComment("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h5>Cancel Meeting</h5>
        <input
          className="form-control my-2"
          placeholder="Enter cancel comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        {error && <p className="text-danger tx-12">{error}</p>}
        <div className="d-flex justify-content-end gap-2 mt-2">
          <button className="btn btn-sm btn-danger" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-sm btn-success" onClick={handleSave}>
            Save
          </button>
          <button
            className="btn btn-sm btn-primary"
            onClick={handleCreateAndSave}
          >
            Save & Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelMeetingModal;
